import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.html',
  styleUrl: './reviews.scss',
})
export class Reviews {
  review: any = environment.ReviewConfig;
}
